import React from 'react';
import { Select, SelectProps } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

const CurrencyDurationRightAddon: React.FC<SelectProps> = ({
  ...selectProps
}) => {
  const { t } = useTranslation();
  return (
    <Select
      _focus={{ boxShadow: 'none', outline: 'none' }}
      _focusVisible={{ boxShadow: 'none', outline: 'none' }}
      borderLeft="none"
      borderRight="none"
      borderTopLeftRadius="0"
      borderBottomLeftRadius="0"
      color="black"
      {...selectProps}
    >
      <option value="ANNUAL">{t('ANNUALLY')}</option>
      <option value="HALF_ANNUAL">{t('HALF_ANNUALLY')}</option>
      <option value="QUARTERLY">{t('QUARTERLY')}</option>
      <option value="MONTHLY">{t('MONTHLY')}</option>
      <option value="ONCE">{t('ONCE')}</option>
    </Select>
  );
};

export default CurrencyDurationRightAddon;
